

export const UseEndPoints = () => {
  return 'fiveprayer/v1'
}

